module.exports = __webpack_public_path__ + "img/style-satellite.c1d7e62a.png";